<template>
    <div class="control-label mt-3">
        <div v-if="label"><span>{{ label }}:</span></div>
        <vue-editor class="mb-3" v-model="myValue" @text-change="updateValue"
                    :disabled="disabled"/>
    </div>
</template>

<script>
import {VueEditor} from 'vue2-editor';

export default {
    name: 'rich-text',
    components: {
        VueEditor,
    },
    props: {
        label: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            myValue: this.value === '' ? '' : this.value,
        };
    },
    methods: {
        updateValue() {
            this.$emit('input', this.myValue);
        },
    },
};
</script>
